
import { defineComponent } from 'vue'

import Overlay from '@/components/gui/Overlay.vue'

export default defineComponent({
	name: 'Loader',

	components: {
		Overlay
	},

	props: {
		value: Boolean
	}
})
